module.exports = __webpack_public_path__ + "f5fa4365fc2f0defc0e3dc48b041e509.png";